<template>
  <div v-if="!emailSent">
    <loader :loading="loading"></loader>
    <div class="container login-page">
      <div class="row">

        <div class="col-lg-4 col-md-6 ml-auto">
          <div class="info-area info-horizontal">
            <div class="icon icon-warning">
              <i class="tim-icons icon-alert-circle-exc"></i>
            </div>
            <div class="description">
              <h3 class="info-title">Reset Password</h3>
              <p class="description">
                To reset your password, please enter the email associated with your account.
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 mr-auto">
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(addEmail)">
              <card class="card-login card-white">
                <template slot="header">
                  <img src="img/card-primary.png" alt="Background" />
                  <h1 class="card-title">Reset</h1>
                </template>

                <div>
                  <validation-provider :rules ="{ email: true, requiredEmail: true }" v-slot="{ errors }">
                    <h6 v-if="errors.length" class="text-danger">
                      <span>{{ errors[0] }}</span>
                    </h6>
                    <base-input
                      name="email"
                      type="email"
                      placeholder="Email"
                      addon-left-icon="tim-icons icon-email-85"
                      v-model="email">
                    </base-input>
                  </validation-provider>
                </div>

                <div slot="footer">
                  <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                    Submit
                  </base-button>
                </div>
              </card>
            </form>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-lg-6 col-md-6 ml-auto mr-auto">
        <div class="info-area info-horizontal">
          <div class="icon icon-primary">
            <i class="tim-icons icon-check-2"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Email Sent!</h3>
            <p class="description">
              Please check your inbox to complete your password reset. If an email doesn't arrive, be sure to check your span or junk mail folder.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Loader from 'src/pages/Survey/Loader';
  import { mapGetters, mapMutations } from 'vuex';
  import { ValidationObserver, ValidationProvider } from 'vee-validate';
  import { resetRequest } from 'src/modules/adminActions';

  export default {
    components: {
      Loader,
      ValidationObserver,
      ValidationProvider
    },
    data() {
      return {
        email: null,
        loading: false,
        emailSent: false
      }
    },
    computed: {
      ...mapGetters(['adminUser'])
    },
    methods: {
      addEmail() {
        this.loading = true;

        let payload = {
          email: this.email,
          callbackUrl: `${process.env.VUE_APP_URL}/admin/reset`
        };

        resetRequest(payload)
          .then(() => {
            this.emailSent = true;
          })
          .finally(() => this.loading = false);
      }
    }
  }
</script>
